import Prismic from 'prismic-javascript';

import { FINANCIAL } from 'translations';

import { MAPPING_PUBLICATIONS_TYPES } from '../helpers/filters';
import { searchFinancialPublication as financialPublicationMapper } from '../helpers/filters/financial-publication';
import {
  toDocPrismic,
  toMediaPrismic,
  toPublicationPrismic,
} from '../schema/prismic/mapping';
import { DocumentType } from '../types/document';
import { MEDIA_TYPE } from '../types/press-media';
import { getDocuments } from './prismic';
import { search } from './search';

export const FILTER_FINANCIAL_PUBLICATION_KEY = 'financial-publication-filter';
export const searchFinancialPublication = search(financialPublicationMapper);

export const loadPublications = (key, year, options = {}) =>
  getDocuments(
    `financial-publication-${year}-${key}`,
    [
      Prismic.Predicates.at(
        'document.type',
        toDocPrismic(DocumentType.MEDIA_PRESS)
      ),
      Prismic.Predicates.at(
        `my.${toDocPrismic(DocumentType.MEDIA_PRESS)}.category`,
        toMediaPrismic(MEDIA_TYPE.PUBLICATION)
      ),
      Prismic.Predicates.not(
        `my.${toDocPrismic(DocumentType.MEDIA_PRESS)}.pub_visible_finance`,
        'non'
      ),
      year &&
        Prismic.Predicates.year(
          `my.${toDocPrismic(DocumentType.MEDIA_PRESS)}.pub_related_date`,
          String(year)
        ),
      MAPPING_PUBLICATIONS_TYPES[key] &&
        (key === FINANCIAL.FIN_PUBLICATION_REFS
          ? Prismic.Predicates.any(
              `my.${toDocPrismic(DocumentType.MEDIA_PRESS)}.publication`,
              [
                toPublicationPrismic(MAPPING_PUBLICATIONS_TYPES[key]),
                toPublicationPrismic(
                  MAPPING_PUBLICATIONS_TYPES[FINANCIAL.FIN_PUBLICATION_URD]
                ),
              ]
            )
          : Prismic.Predicates.at(
              `my.${toDocPrismic(DocumentType.MEDIA_PRESS)}.publication`,
              toPublicationPrismic(MAPPING_PUBLICATIONS_TYPES[key])
            )),
    ].filter(Boolean),
    {
      pageSize: 6,
      orderings: `[my.${toDocPrismic(
        DocumentType.MEDIA_PRESS
      )}.pub_related_date desc]`,
      ...options,
    }
  );
